// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"4ffa18f96cc1d954fff3","245":"ad9dfa3f2da957de666f","452":"4bd47ae17c3e9eaa53c9","453":"ee89d30ce8ad9691bb0f"}[chunkId] + ".js";
};